import React from 'react';
import { Col, Layout, Row, Typography, } from "antd";
import { IStaticPageMenu } from './typings';
import { Link } from 'react-router-dom';
import { routes } from 'Routes';
import logo from "../../assets/logo.svg";

const { Sider } = Layout;
const { Title } = Typography;

const StaticSider: React.FC<IStaticPageMenu> = (props: IStaticPageMenu) => {
    return (
        <Sider theme="light" className="sider" breakpoint="md" collapsedWidth="0">
        <Row className="mb-12">
            <Col offset={2} span={22}>
                <Title level={1} className="mt-18 mb-18">
                    <Link to={routes.home.new}>
                        <img className="pb-4" src={logo} alt="JitFin" />
                    </Link>
                </Title>
            </Col>
            </Row>
            <nav>
                {props.links.map((link: string[]) => (
                    <Row className="mb-12">
                        <Col offset={2} span={22}>
                            <a href={link[1]} title={link[0]}>{link[0]}</a>
                        </Col>
                    </Row>
                ))}
            </nav>
        </Sider>
    )
};
export default StaticSider